import { t } from 'i18next';
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'
import languageDE from '../assets/content/de.json';
import languageEN from '../assets/content/en.json';
import languageTR from '../assets/content/tr.json';
import { GLOBALS } from '../model/constants';
export const translation = (input:any) => {
    if(!input)
        return "";
    return t(input);
}

export const changeLanguage = (lng: string) => {
    
    GLOBALS.language = lng;
    i18n.language = lng;
    i18n.changeLanguage(lng);
    window.location.reload();
    
    // console.log(GLOBALS.language);
    // i18n.reloadResources();
    // i18n.getDataByLanguage(lng);

}